import { UseCase } from '@cp/shared/usecase';
import { AuthOTPCodeModalProps, ILoginUseCaseParameters, LoginFeatureResult, LoginModalOwnProps } from './types';

export class LoginUseCase implements UseCase<ILoginUseCaseParameters> {
  constructor(
    private readonly loginModal: (parameters: LoginModalOwnProps) => Promise<LoginFeatureResult>,
    private readonly otpCodeModal: (p: AuthOTPCodeModalProps) => Promise<void>,
  ) {}

  async execute(parameters: ILoginUseCaseParameters = {}): Promise<void> {
    const { clientSelection, ...loginModalProps } = parameters;

    let isLoginShouldBeRetrieved = true;
    do {
      const loginResult = await this.loginModal(loginModalProps);
      isLoginShouldBeRetrieved = false;

      await this.otpCodeModal({
        onChangeLogin: ({ closeModal }) => {
          isLoginShouldBeRetrieved = true;
          closeModal();
        },
        clientSelection,
        ...loginResult,
        actionOnAuthSuccess: 'redirectToCatalog',
      });
    } while (isLoginShouldBeRetrieved);

    // TODO: check sms code result and handle registration flow
  }
}
